import { React, useContext, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { isFuture } from 'date-fns'
import { useWindowSize } from 'hooks'
import { CSSTransition } from 'react-transition-group'
import { UiContext } from 'context/ui'

import { ChatPopup } from 'components/Dashboard/ChatPopup'

import {
  DashboardAccount,
  DashboardReminder,
  DashboardSidebar,
  DashboardRecentCalls,
  DashboardHeader,
} from 'components/Dashboard'
import { MeetingsAndCalls } from 'components/Dashboard/MeetingsAndCalls'
import {
  Popup,
  AddVideoPopup,
  SendInvitePopup,
  ClassesPopup,
  ManageSubscriptionPopup,
} from 'components/Popups'
import { CreateClassForm } from 'components/CreateClassForm'
import { AvailabilityForm } from 'components/AvailabilityForm'
import HelpPopup from 'components/Popups/HelpPopup/HelpPopup'
import ProfilePopup from 'components/Popups/ProfilePopup/ProfilePopup'

import APP_DATA from 'utils/appData'
import { DASHBOARD_CONTENT_STATES, MEDIA_BREAKPOINTS, POPUPS_ID } from 'utils/constants'

import styles from './TalkerPage.module.scss'

import { profileApi } from 'api'

import { setCalls, setRequests, logIn, setEvents } from 'store/actions'
import { LiveChatLink } from 'components/LiveChatLink'

const TalkerPage = (props) => {
  const {
    activePopupId,
    setActivePopupId,
    dashboardTabIndex,
    setDashboardTabIndex,
    setSentInvite,
    setCreatedClass,
    setIsNewUser,
    sentInvite,
    createdClass,
  } = useContext(UiContext)
  const [isSidebarOpen, setSidebarOpen] = useState(false)
  const [contentState, setContentState] = useState(DASHBOARD_CONTENT_STATES.default)

  useEffect(() => {
    if (props?.events?.filter((e) => isFuture(new Date(e?.scheduled_at)))?.length > 0) {
      setCreatedClass(true)
    }
    if (props?.calls?.filter((e) => isFuture(new Date(e?.scheduled_at)))?.length > 0) {
      setSentInvite(true)
    }
    if (createdClass && sentInvite) {
      setIsNewUser(false)
    }
  }, [
    createdClass,
    props?.calls,
    props?.events,
    sentInvite,
    setCreatedClass,
    setIsNewUser,
    setSentInvite,
  ])
  useEffect(() => {
    document.title = 'TalkPro | Dashboard'
  }, [])

  const windowSize = useWindowSize()

  const toggleSidebar = () => {
    setActivePopupId(null)
    setSidebarOpen(!isSidebarOpen)
  }

  const mobileTabsHandler = (index) => {
    setDashboardTabIndex(index)
  }

  const calendarCount = [...(props?.calls || []), ...(props?.events || [])].filter(
    (item) =>
      item &&
      isFuture(new Date(item?.scheduled_at)) &&
      !item?.canceled &&
      !item?.finished_at
  ).length

  const onClosePopup = async () => {
    setActivePopupId(null)

    await profileApi
      .getProfileInfo()
      .then((res) => props.logIn(res?.result?.profile))
      .then((e) => {
        window.location.reload()
      })
  }

  return (
    <div className={styles.dashboard}>
      {windowSize.width < MEDIA_BREAKPOINTS.lg && (
        <DashboardHeader
          handleClick={toggleSidebar}
          mobileTabsHandler={mobileTabsHandler}
          activeIndex={dashboardTabIndex}
          calendarCount={calendarCount}
        />
      )}
      {windowSize.width >= MEDIA_BREAKPOINTS.lg ? (
        <div className={`${styles.col} ${styles.sidebarCol}`}>
          <DashboardSidebar
            setDashboardContent={setContentState}
            dashboardContentCurrentState={contentState}
          />
        </div>
      ) : (
        <CSSTransition
          in={isSidebarOpen}
          timeout={{
            enter: 500,
            exit: 350,
          }}
          classNames={{
            enter: styles['popup-enter'],
            enterActive: styles['popup-enter-active'],
            exitActive: styles['popup-exit-active'],
            enterDone: styles['popup-enter-done'],
          }}
          mountOnEnter
          unmountOnExit
        >
          <div className={styles['DashboardSidebar_wrap']}>
            <DashboardSidebar
              toggleSidebar={toggleSidebar}
              isSidebarOpen={isSidebarOpen}
              toggleClass={styles['popup-enter-done']}
              setDashboardContent={setContentState}
              dashboardContentCurrentState={contentState}
            />
          </div>
        </CSSTransition>
      )}
      {contentState === DASHBOARD_CONTENT_STATES.default && (
        <div className={`${styles.col} ${styles.talksCol}`}>

          {windowSize.width >= MEDIA_BREAKPOINTS.lg && (
            <><DashboardReminder />
            <DashboardRecentCalls toggleSidebar={toggleSidebar} />
            </>
          )}
          {windowSize.width < MEDIA_BREAKPOINTS.lg && dashboardTabIndex === 0 && (

             <>
            <DashboardReminder />
            <DashboardRecentCalls toggleSidebar={toggleSidebar} />
            </>
          )}

        </div>
      )}
      <div className={`${styles.col} ${styles.infoCol}`}>
        {windowSize.width >= MEDIA_BREAKPOINTS.lg && (
          <DashboardAccount user={props.user} />
        )}
        {contentState === DASHBOARD_CONTENT_STATES.default && (
          <>

            <MeetingsAndCalls />
          </>
        )}
        <ChatPopup/>

      </div>


      <Popup
        isOpen={activePopupId === POPUPS_ID.createClass}
        title={
          window.localStorage.getItem('editEvent')
            ? APP_DATA.popups.editClass.title
            : APP_DATA.popups.createClass.title
        }
        description={
          window.localStorage.getItem('editEvent')
            ? APP_DATA.popups.editClass.description
            : APP_DATA.popups.createClass.description
        }
        centerContent
      >
        <CreateClassForm
          onSubmitCallback={onClosePopup}
          initialValues={
            props?.user?.live_classes_service ? props?.user?.live_classes_service : null
          }
          pro={props?.user}
          isOpen={activePopupId === POPUPS_ID.createClass}
          onSignup={false}
        />
      </Popup>
      <Popup
        isOpen={activePopupId === POPUPS_ID.availability}
        title={APP_DATA.popups.availability.title}
        description={APP_DATA.popups.availability.description}
        centerContent
      >
        <AvailabilityForm
          onSubmitCallback={onClosePopup}
          subscriptionPlan={props?.user?.subscription_plan}
          initialValues={props?.user?.one_on_one_service}
        />
      </Popup>
      <AddVideoPopup
        isOpen={activePopupId === POPUPS_ID.addVideo}
        user={props?.user}
        title="YouTube Sync"
        description="Selected videos for your public booking page. We recommend adding videos that explain what you do and highlight your value proposition."
      />
      <SendInvitePopup
        isOpen={activePopupId === POPUPS_ID.sendInvite}
        user={props?.user}
      />
      <ClassesPopup isOpen={activePopupId === POPUPS_ID.classes} />
      <HelpPopup isOpen={activePopupId === POPUPS_ID.help} />
      {/* <BillingPopup isOpen={activePopupId === POPUPS_ID.billing} /> */}
      <ProfilePopup isOpen={activePopupId === POPUPS_ID.profile} />
      <ManageSubscriptionPopup
        isOpen={activePopupId === POPUPS_ID.manageSubscriptionPopup}
        title="Manage Subscription"
        description="Everything you need is ready—organized, summarized, and simple to use from the moment you log in."
        centerContent
      />

      <LiveChatLink user={props?.user} />
    </div>
  )
}

const mapStateToProps = ({ auth: { error, isPro, user, events, calls } }) => ({
  authError: error,
  user,
  isPro,
  events,
  calls,
})

const willMapDispatchToProps = {
  setRequests,
  setCalls,
  logIn,
  setEvents,
}

export default connect(mapStateToProps, willMapDispatchToProps)(TalkerPage)
